import { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';

import { useAuth } from '../../auth/AuthProvider.jsx';
import { ApiError } from '../../api/client.js';
import { Card } from '../../components/ui/Card.jsx';
import { Input } from '../../components/ui/Input.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { t } from '../../lib/i18n.js';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Authentication panel shown when the kiosk tablet is not yet logged
 * in. The device authenticates once as a kiosk user; the session is
 * then long-lived via the refresh cookie.
 */
export function KioskAuthPanel() {
  const { login } = useAuth();
  const [submitting, setSubmitting] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm({ defaultValues: { email: '', password: '' } });

  const onSubmit = async (values) => {
    setSubmitting(true);
    try {
      await login({ email: values.email.trim(), password: values.password });
      toast.success('Postazione attivata.');
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : t('common.error');
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-12">
      <Card>
        <header className="mb-5">
          <h1 className="text-xl font-semibold text-ink">Configura la postazione</h1>
          <p className="mt-1 text-sm text-ink-muted">Inserisci le credenziali dell'account kiosk del negozio.</p>
        </header>
        <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)} noValidate>
          <Input
            label="Email"
            type="email"
            autoFocus
            autoComplete="email"
            error={errors.email && (errors.email.message || 'Email non valida')}
            {...register('email', { required: 'Email richiesta', pattern: { value: EMAIL_RE, message: 'Formato email non valido' } })}
          />
          <Input
            label="Password"
            type="password"
            autoComplete="current-password"
            error={errors.password && (errors.password.message || 'Password richiesta')}
            {...register('password', { required: 'Password richiesta' })}
          />
          <Button type="submit" loading={submitting}>Attiva postazione</Button>
        </form>
      </Card>
    </div>
  );
}
